export const WHATSAPP_CONNECTOR_NAME = 'Whatsapp Connector';
/**
 * The WhatsApp connector that goes through Gupshup as BSP. Its display name carries no trace of
 * the provider on purpose — to the customer it is just the channel — so the two WhatsApp
 * connectors are told apart by this name alone.
 */
export const WHATSAPP_BUSINESS_CONNECTOR_NAME = 'Whatsapp Business';
/**
 * Every name the WhatsApp channel can be connected under: Meta's connector, whose row was seeded
 * under two different names over time, and Whatsapp Business. For screens that only need to know
 * whether the channel is usable — which connector serves it is
 * {@code useWhatsappChannelConnector}'s job.
 */
export const WHATSAPP_CONNECTOR_NAMES = [WHATSAPP_CONNECTOR_NAME, 'Whatsapp', WHATSAPP_BUSINESS_CONNECTOR_NAME];
